import React from 'react';
import { Button, Drawer } from 'components/Elements';
import { CheckboxField } from 'components/Form';

export const FiltersDrawer = ({ isOpen, onClose }) => {
  return (
    <Drawer
      title="Filters"
      isOpen={isOpen}
      onClose={() => {
        onClose();
      }}
      renderFooter={() => {
        return (
          <>
            <Button variant="glass">Apply Filters</Button>
          </>
        );
      }}
      size="md"
    >
      <div className="">
        <div className="">Status</div>
        <div className="">
          <div className="flex flex-row items-center space-x-1">
            <input type="checkbox" className="" /> <div className="">All</div>
          </div>
          <div className="flex flex-row items-center space-x-1">
            <input type="checkbox" className="" />{' '}
            <div className="">Pending</div>
          </div>
          <div className="flex flex-row items-center space-x-1">
            <input type="checkbox" className="" />{' '}
            <div className="">Waiting List</div>
          </div>
          <div className="flex flex-row items-center space-x-1">
            <input type="checkbox" className="" />{' '}
            <div className="">Not Setup</div>
          </div>
          <div className="flex flex-row items-center space-x-1">
            <input type="checkbox" className="" />{' '}
            <div className="">Inactive</div>
          </div>
          <div className="flex flex-row items-center space-x-1">
            <input type="checkbox" className="" />{' '}
            <div className="">Active</div>
          </div>
          <div className="flex flex-row items-center space-x-1">
            <input type="checkbox" className="" />{' '}
            <div className="">Incomplete Setup</div>
          </div>
        </div>
      </div>
    </Drawer>
  );
};
